/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {AppBar, Box, Toolbar, Typography} from '@mui/material'
import React, {useState} from 'react'
import {TranslatedText} from '@enisco/mcc-react-lib'
import Clock from './Clock'
import UserBox from './UserBox'
import Logo from './icons/Logo'
import useCurrentApp from '../../hooks/useCurrentApp'
import AppSelector from '../menu/AppSelector'
import {AppContextMenu} from './menus/AppContextMenu'
import {AppContextMenuButton} from './AppContextMenuButton'
import {Theme} from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import useFavoriteApp from '../../hooks/useFavoriteApp'

//TODO check why typescript doesnt get it if this is defined in react-lib
declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    titleBar: true
  }
}

const TitleBar: React.FC = () => {
  const [contextMenuAnchor, setContextMenuAnchor] = useState<Element>()
  const [currentApp] = useCurrentApp()
  const [favorite] = useFavoriteApp()
  const hidden = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  const app = favorite ?? currentApp

  return (
    <AppBar
      position='relative'
      sx={{ height: '64px', flex: '0 1 auto' }}
      enableColorOnDark
      color={'titleBar'}
    >
      <Toolbar sx={{ height: '64px' }}>
        <Box flexDirection='row' display='flex' alignItems='center'>
          <AppSelector />
          <Logo
            darkIcon={'/mcc-portal-ui/AC4DC_dark_wortmarke.svg'}
            lightIcon={'/mcc-portal-ui/AC4DC_light_wortmarke.svg'}
            height={'30px'}
          />

          {hidden ? null : (
            <Typography variant='h6' sx={{ paddingLeft: 1.5 }}>
              {app ? (
                <TranslatedText text={app.description} />
              ) : undefined}
            </Typography>
          )}

          {currentApp ? (
            <AppContextMenuButton setMenuAnchor={setContextMenuAnchor} />
          ) : undefined}
          <AppContextMenu
            anchorEl={contextMenuAnchor}
            setAnchorEl={setContextMenuAnchor}
          />
        </Box>

        <Box sx={{ flexGrow: 1, textAlign: 'center' }} display='flex' />

        <Box flexDirection='row' display='flex' alignItems='center'>
          <UserBox />
          {hidden ? null : <Clock sx={{ marginLeft: 2, marginRight: 2 }} />}
          {hidden ? null : (
            <Logo
              darkIcon={'/mcc-portal-ui/FORCAM_ENISCO_2025_dark_backgrounds.svg'}
              lightIcon={'/mcc-portal-ui/FORCAM_ENISCO_2025.svg'}
              height={'30px'}
            />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default TitleBar
